// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"90ad304b","75":"ad283c48","193":"0bd43430","478":"1aee6abb","482":"fdab0470","667":"3341953f","892":"94d91e78"}[chunkId] + ".chunk.js";
};